// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__RyAki","footer__trust_box":"Footer_footer__trust_box__CfmBx"};